var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container-with-scroll-prop",
    { attrs: { scroll: !_vm.noScroll } },
    [
      _c(
        "w-row",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                [
                  _c("app-company-info-navigation", {
                    attrs: { company: _vm.company },
                  }),
                  _c("w-spacer"),
                  _vm._t("search"),
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _vm.hasPermission("companies.write")
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.editCompanyToolTipText,
                                  expression: "editCompanyToolTipText",
                                },
                              ],
                              staticClass: "edit-button",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.editCompany()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          )
                        : _vm._e(),
                      _vm._t("actions"),
                    ],
                    2
                  ),
                ],
                2
              ),
              _c("w-row"),
            ],
            1
          ),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }